const PROVIDER_DETAIL_TEMPLATE = {
  name: {
    type: "text",
    displayStyle: "text",
    label: "Name",
    placeholder: "Enter the name of the provider",
    required: true,
    modelKey: "name",
    display: false,
  },

  providerTypes: {
    type: "select",
    displayStyle: "chip",
    label: "Provider Type",
    placeholder: "Select the type of provider",
    required: true,
    availableInModel: true,
    modelKey: "providerTypes",
    modelValueKey: "id",
    modelValueLabel: "name",
    display: true,
  },

  address: {
    type: "address",
    displayStyle: "text",
    label: "Address",
    placeholder: "Enter the address of the provider",
    required: true,
    modelKey: "address.raw",
    display: true,
  },

  email: {
    type: "text",
    displayStyle: "text",
    label: "Main Email",
    placeholder: "Enter the email of the provider",
    required: true,
    modelKey: "email",
  },

  phone: {
    type: "text",
    displayStyle: "text",
    label: "Phone Number",
    placeholder: "Enter the phone number of the provider",
    required: true,
    modelKey: "phone",
    display: true,
  },

  homepageUrl: {
    type: "text",
    displayStyle: "text",
    label: "Website URL",
    placeholder: "Enter the homepage URL of the provider",
    required: false,
    modelKey: "homepageUrl",
    display: true,
  },

  communicationPreference: {
    type: "select",
    displayStyle: "text",
    label: "Communication Preference",
    placeholder: "Select the communication preference of the provider",
    required: false,
    availableInModel: false,
    url: "field_options/",
    queryParams: {
      content_type: "provider",
      field_name: "communication_preference",
      flat: "True",
    },
    modelKey: "communicationPreference",
    modelValueKey: "key",
    modelValueLabel: "label",
    modelValueKeyType: Number,
    display: true,
  },
};

export default PROVIDER_DETAIL_TEMPLATE;
